import type { SxProps, Theme } from "@mui/material";
import { Box } from "@mui/material";
import type { ReactNode } from "react";

interface SlideTextContainerProps {
  children: ReactNode;
  sx?: SxProps<Theme>;
}

export function SlideTextContainer({ children, sx }: SlideTextContainerProps) {
  return (
    <Box
      sx={{
        flex: 42,
        paddingX: 2,
        paddingTop: 3,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        minHeight: 0,
        ...sx,
      }}
    >
      {children}
    </Box>
  );
}
